import { useEffect, useState } from "react"
import { Table, Form, Row, Col, InputGroup } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { actions } from "../../../data/applicationSlice"
import { getContractingServices } from "../../../data/enumSlice"

const { updateAdminApplication, updateApplicationData } = actions
const ContractingServices = ({ questionNumber, validationError, setValidationErrors }) => {
    const [columnsData, setColumnsData] = useState({})
    const { fetchStatus, application } = useSelector((state) => state.application)
    const { services } = useSelector((state) => state.enums)
    const [leftColumnData, setLeftColumnData] = useState([])
    const [rightColumnData, setRightColumnData] = useState([])
    const [totalPercent, setTotalPercent] = useState(0)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getContractingServices())
    }, [])

    useEffect(() => {
        if (validationError?.contractingServicesTotalPercentage && totalPercent === 100) {
            setValidationErrors((preErrors) => {
                const newError = { ...preErrors }
                if (newError["contractingServicesTotalPercentage"]) {
                    delete newError["contractingServicesTotalPercentage"]
                }
                return newError
            })
        }
    }, [totalPercent])

    const handleInputChange = (event) => {
        const { value, name } = event.target
        if (name === "contractingServiceOtherLabel") {
            dispatch(
                updateApplicationData({
                    field: "contractingServiceOtherLabel",
                    value
                })
            )
            return
        }
        const numericValue = +value.replace(/\D/g, "")

        if (numericValue > 100) {
            alert("Percentage must be less than or equal to 100%")
            return
        }
        dispatch(
            updateApplicationData({
                field: name,
                value: numericValue
            })
        )
    }

    useEffect(() => {
        const contractingServices = Object.keys(application).filter((key) => key.startsWith("contractingService")) ?? []
        const populatedServices = services?.map((service) => {
            const index = contractingServices.findIndex((item) => item.key === service.key)
            if (index !== -1) {
                return { ...service, ...contractingServices[index] }
            }
            return service
        })
        setLeftColumnData(populatedServices?.filter((item, index) => index % 2 === 0))
        setRightColumnData(populatedServices?.filter((item, index) => index % 2 !== 0))
        setColumnsData(populatedServices)
    }, [services, fetchStatus])

    useEffect(() => {
        let percent = 0
        let allColumns = [...leftColumnData, ...rightColumnData]

        allColumns?.forEach((item) => {
            if (item.key.includes("Label")) {
                return
            }
            const value = parseInt(application[item.key] ?? 0)
            if (!isNaN(value)) {
                percent += parseInt(value)
            }
        })

        percent += parseInt(application["contractingServiceOther"] ?? 0)

        setTotalPercent(percent)
    }, [leftColumnData, rightColumnData, fetchStatus])

    return (
        <div className="mt-4 percentages">
            <h6
                className={`
            ${validationError?.contractingServicesTotalPercentage ? "text-error" : ""}
            `}>
                {questionNumber}. Contracting Services - Please provide information associated with the following
                Contracting Services. Please note that percentages must add up to 100%.
            </h6>

            <Row>
                <Col
                    sm={6}
                    className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Contracting Services</th>
                                <th>Percentage of Annual Revenue of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leftColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">{item.name}</td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                name={item.key}
                                                value={application[item.key] || ""}
                                                onChange={(e) => {
                                                    const copiedData = [...leftColumnData]
                                                    let index = copiedData?.findIndex((i) => i.id === item.id)
                                                    if (index !== -1) {
                                                        copiedData[index] = {
                                                            ...copiedData[index],
                                                            value: +e.target.value
                                                        }
                                                    }
                                                    setLeftColumnData(copiedData)
                                                    setColumnsData([...rightColumnData, ...leftColumnData])
                                                    handleInputChange(e)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
                <Col
                    sm={6}
                    className="p-0">
                    <Table
                        striped
                        bordered
                        hover
                        className="mt-2">
                        <thead>
                            <tr>
                                <th>Contracting Services</th>
                                <th>Percentage of Annual Revenue of current calendar year</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rightColumnData?.map((item, index) => (
                                <tr key={item.id}>
                                    <td className="align-middle">
                                        {item.name === "Other (please describe)" ? (
                                            <Form.Control
                                                className="form-control-sm"
                                                placeholder="Other (please describe)"
                                                value={
                                                    typeof application["contractingServiceOtherLabel"] === "string"
                                                        ? application["contractingServiceOtherLabel"]
                                                        : ""
                                                }
                                                name={item.name === "Other (please describe)" ? "name" : ""}
                                                onChange={(e) => {
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name: "contractingServiceOtherLabel"
                                                        }
                                                    }
                                                    handleInputChange(event)
                                                }}
                                            />
                                        ) : (
                                            item.name
                                        )}
                                    </td>
                                    <td className="percentage-column">
                                        <InputGroup>
                                            <Form.Control
                                                className={`form-control-sm`}
                                                max={100}
                                                min={0}
                                                value={
                                                    item.name === "Other (please describe)"
                                                        ? application["contractingServiceOther"]
                                                        : application[item.key] || ""
                                                }
                                                onChange={(e) => {
                                                    let copiedData = [...rightColumnData]
                                                    let index = copiedData?.findIndex((i) => i.id === item.id)

                                                    if (index !== -1) {
                                                        copiedData[index] = {
                                                            ...copiedData[index],
                                                            value: +e.target.value
                                                        }
                                                    }
                                                    setRightColumnData(copiedData)
                                                    setColumnsData([...leftColumnData, ...copiedData])
                                                    let event = {
                                                        target: {
                                                            value: e.target.value,
                                                            name:
                                                                item.name === "Other (please describe)"
                                                                    ? "contractingServiceOther"
                                                                    : item.key
                                                        }
                                                    }
                                                    handleInputChange(event)
                                                }}
                                            />
                                            <InputGroup.Text id="basic-addon2">%</InputGroup.Text>
                                        </InputGroup>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p className={totalPercent !== 100 ? "total-percent text-error" : "total-percent"}>
                        Total Percent: {totalPercent}%
                    </p>
                </Col>
            </Row>
        </div>
    )
}

export default ContractingServices
